import courseList, { CourseListParams } from "@/getinfo-api/course";
import api, { courseApi } from "@/getinfo-api";
import { MainList } from "@/classes/MainList";
import { Course as ICourse } from "@/api/models/course";
import { uniqBy } from "lodash";

export class CoursesListClass extends MainList {
  params: CourseListParams = {
    ownerIds: this.isNeedOwnerId ? undefined : [this.userId],
    companyIds: [this.companyId],
    limit: 30,
    offset: 0
  };

  constructor(params?: any, selectedValue?: string | undefined) {
    super();
    this.method = courseList;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    this.dataLabel = "courses";
    if (selectedValue) {
      courseList({ ids: [selectedValue], mode: "v2" }).then(res => {
        this.listItems = uniqBy([res.data.courses[0], ...this.listItems], "id");

        this.singleResult = res.data.courses[0];
      });
    }
    this.list();
  }

  search(value: string) {
    this.params.title = value;
    this.params.offset = 0;
    this.listItems = [];
    this.list();
  }

  get courses(): Array<ICourse> {
    return this.listItems;
  }
}
